const service = function (
	Http,
	$q
) {
	"ngInject";

	this.get = (id, data) => Http.get('/v1/product/'+id, false, data);
	this.all = (data) => {

		var canceller = $q.defer();

        return {
        	cancel: function() {
        		canceller.resolve();
        	},
        	promise: Http.request('/v1/product', data, {
        		method: 'POST',
        		timeout: canceller.promise
        	})
        }
	}

	this.status = (id) => Http.get('/v1/product/status/'+id);
	this.comments = (id) => Http.get('/v1/product/'+id+'/comments');
	this.comment = (id, text) => Http.post('/v1/product/'+id+'/comment', 'POST', {
		text: text
	});
	this.deleteComment = (id) => Http.post('/v1/product/comment/'+id, 'DELETE');
	this.find = (data) => Http.get('/v1/product/find', false, data);
	this.log = (data) => Http.post('/v1/product/log', 'POST', data);
	this.priceOverwrite = (data) => Http.post('/v1/product/price-overwrite', 'POST', data);

};

export default service;



// WEBPACK FOOTER //
// ./app/components/product/product.service.js